import React from 'react';
import soldout from '../assets/swatches/soldout.png';
import ReactPlayer from 'react-player';
import Flickity from 'react-flickity-component';
import jQuery from "jquery";
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';


function HtmlEncode(s){
  var el = document.createElement("div");
  el.innerText = el.textContent = s;
  s = el.innerHTML;
  return s;
}

const flickityOptions = {
    initialIndex: 0
}

var hasRun = "";
let newObj = {};
var tapAreaGallery;

function add(a, b) {
    return a + b;
}

function obj(){
    obj=new Object();
    this.add=function(key,value){
        obj[""+key+""]=value;
    }
    this.obj=obj
}

function isEmpty(obj) {
    for(var prop in obj) {
        if(obj.hasOwnProperty(prop))
            return false;
    }

    return JSON.stringify(obj) === JSON.stringify({});
}

function formatMoney(n, c, d, t) {
  var c = isNaN(c = Math.abs(c)) ? 2 : c,
    d = d == undefined ? "." : d,
    t = t == undefined ? "," : t,
    s = n < 0 ? "-" : "",
    i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
    j = (j = i.length) > 3 ? j % 3 : 0;

  return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
};

function waitForReactPlayerLoad(callback) {
	const modal = document.querySelector('.lightbox-overlay.open.active');
	if (!modal) return;

	// Poll for the iframe element
	const checkInterval = setInterval(() => {
		const iframe = modal.querySelector('iframe');
		if (iframe && iframe.contentWindow) {
		clearInterval(checkInterval);

		// Wait for iframe's internal load
		iframe.addEventListener('load', () => {
			callback(iframe);
		});

		// Fallback: some iframe players load instantly
		if (iframe.readyState === 'complete') {
			callback(iframe);
		}
		}
	}, 50);
}

function priceCalulator(array, productid){
	let total = 0.00
	let cartArray = array
	let totalprice = 0.00
	cartArray.map((product, i) =>
		{

			if(product.productID === productid){
				if(product.cartObjects.length > 0){
					product.cartObjects.map((obj, i) =>
					total += obj.price/100 * obj.quanitity
					);
				}
				totalprice = formatMoney(total)

			}
		}
	);
	return totalprice
}

function evaluateIfSoldOut(available){
	if(!available){
		return 'sold-out'
	}else{
		return ''
	}
}

function evaluateIfSoldOutReturnQ (product, q) {
	let finalCount = 0;
	if(product.title.includes("Wipe Up Wash") || product.title.includes("Washing Powder")){
		let available = product.variants[0].available
		if(available){
			finalCount = 200;
		}
	}else{
		product.variants.map((variant,i) => {
			if(variant.available){
				finalCount += 200
			}
		});
	}
	if(finalCount <= 0){
		return 0
	}else{
		return q
	}
}

function fireClick(node){
    if (document.createEvent) {
        var evt = document.createEvent('MouseEvents');
        evt.initEvent('click', true, false);
        node.dispatchEvent(evt);
    } else if (document.createEventObject) {
        node.fireEvent('onclick') ;
    } else if (typeof node.onclick == 'function') {
        node.onclick();
    }
}

function priceObjectCalulator(obj){
	let total = 0.00
	let cartObj = obj
	if(cartObj.cartObject.length > 1){
		cartObj.cartObject.map((obj, i) =>
			total += obj.price * obj.quanitity
		);
	}
	let totalprice = formatMoney(total/100)
	return totalprice

}
function simplePriceCalc(quant, price){
	let total = formatMoney(quant * (price))

	return total
}

class ProductOverlay extends React.Component {

	constructor(props){
	    // Pass props to parent class
	    super(props);
	    // Set initial state
	    this.state = {
	      videoOverlay: false,
	      videoOverlayURL: '',
	      productQuantity: 0,
	      description: '',
	      price: '',
	      panel: 0,
	      backgroundImage: '',
	      minicart: {},
	      cart: [],
	      instructionsOverlay: false,
	      instructions: '',
	      size: '',
	      title: '',
	      totalprice: "TOTAL: $ " + 0.00,
	      product: {
	      	'variants': [
	      		{
	      			"options": [""]
	      		}
	      	],
	      	'meta': []

	      },
	      galleryImages: [],
	      imageVariants: [],
	      productVariants: []
	    }

 		this.closeOverlayAndSave 	= this.closeOverlayAndSave.bind(this);
 		this.renderDescription		= this.renderDescription.bind(this);
 		this.renderPrints			= this.renderPrints.bind(this);
 		this.renderNewInstructions	= this.renderNewInstructions.bind(this);
 		this.renderBackgroundImage  = this.renderBackgroundImage.bind(this);
 		this.updateMiniCart			= this.updateMiniCart.bind(this);
 		this.evaluateIfTooMany		= this.evaluateIfTooMany.bind(this);
 		this.reduceQuantity			= this.reduceQuantity.bind(this);
 		this.renderInput			= this.renderInput.bind(this);
 		this.getDefaultInputValue	= this.getDefaultInputValue.bind(this);
 		this.increment 				= this.increment.bind(this);
 		this.decrement 				= this.decrement.bind(this);
 		this.setActivePrints		= this.setActivePrints.bind(this);
 		this.showVariantFeaturedImages = this.showVariantFeaturedImages.bind(this);
 		this.showThisProductSpecificImage = this.showThisProductSpecificImage.bind(this);
 		this.showThisProductSpecificImageGallery = this.showThisProductSpecificImageGallery.bind(this);
 		this.evaluateIfActive = this.evaluateIfActive.bind(this);
 		this.openVideoOverlay = this.openVideoOverlay.bind(this);
 		this.openInstructionsOverlay = this.openInstructionsOverlay.bind(this);
 		this.closeVideoOverlay = this.closeVideoOverlay.bind(this);
 		this.closeInstructionsOverlay = this.closeInstructionsOverlay.bind(this);
 		this.renderVideoIframe = this.renderVideoIframe.bind(this);
 		this.updateQuantityWhole = this.updateQuantityWhole.bind(this);
 		this.reduceQuantityAccessibility = this.reduceQuantityAccessibility.bind(this);
 		this.evaluateVariantAccessibility = this.evaluateVariantAccessibility.bind(this);
 		this.updateQuantityAccessibility = this.updateQuantityAccessibility.bind(this);
 		this.showVariantFeaturedImagesAccessibility = this.showVariantFeaturedImagesAccessibility.bind(this);
 		this.evaluateIfTooManyAccessibility = this.evaluateIfTooManyAccessibility.bind(this);
 		this.closeInstructionsOverlayAccessibility = this.closeInstructionsOverlayAccessibility.bind(this);
 		this.closeVideoOverlayAccessibility = this.closeVideoOverlayAccessibility.bind(this);
 		this.openInstructionsOverlayAccessibility = this.openInstructionsOverlayAccessibility.bind(this);
 		this.openVideoOverlayAccessibility = this.openVideoOverlayAccessibility.bind(this);
 		this.showThisProductSpecificImageGalleryAccessibility = this.showThisProductSpecificImageGalleryAccessibility.bind(this);
 		this.showThisProductSpecificImageAccessibility = this.showThisProductSpecificImageAccessibility.bind(this);
 		this.closeOverlayAndSaveAccessibility = this.closeOverlayAndSaveAccessibility.bind(this);
 		this.ifReadyToSaveGoAheadAndSaveAndClose = this.ifReadyToSaveGoAheadAndSaveAndClose.bind(this);
 		this.ifReadyToSaveGoAheadAndSaveAndCloseAccessibility = this.ifReadyToSaveGoAheadAndSaveAndCloseAccessibility.bind(this);
 		this.printTotalsMessage = this.printTotalsMessage.bind(this);
 		this.printTotalsMessageAction = this.printTotalsMessageAction.bind(this);
 		this.getSlugHandle = this.getSlugHandle.bind(this);
	}


	getSlugHandle(handle){
		let imageslug = handle.replace(/\s+/g, '').toLowerCase();
		return imageslug
	}

	evaluateIfActive(i){
		if(i == 0){
			return 'active'
		}else{
			return '';
		}
	}

	ifReadyToSaveGoAheadAndSaveAndCloseAccessibility(e){
		if(this.state.readyToSave){
			if(e.which == 13 || e.keyCode == 13) {
				this.closeOverlayAndSave(e);
			}
		}
	}

	closeOverlayAndSaveAccessibility(e){
		if(e.which == 13 || e.keyCode == 13) {
			this.closeOverlayAndSave(e);
		}
	}

	closeVideoOverlayAccessibility(e){
		if(e.which == 13 || e.keyCode == 13) {
			this.closeVideoOverlay(e);
		}
	}

	closeInstructionsOverlayAccessibility(e){
		if(e.which == 13 || e.keyCode == 13) {
			this.closeInstructionsOverlay(e);
		}
	}

	reduceQuantityAccessibility(swatch, e){
		if(e.which == 13 || e.keyCode == 13) {
			this.reduceQuantity(swatch);
		}
	}

	evaluateVariantAccessibility(a,b,e){
		if(e.which == 13 || e.keyCode == 13) {
			this.evaluateVariant(a,b,e)
		}
	}

	updateQuantityAccessibility(e){
		if(e.which == 13 || e.keyCode == 13) {
			this.updateQuantity(e);
		}
	}

	showThisProductSpecificImageAccessibility(e,a,b){
		if(e.which == 13 || e.keyCode == 13) {
			this.showThisProductSpecificImage(e,a,b);
		}
	}

	showThisProductSpecificImageGalleryAccessibility(e, a){
		if(e.which == 13 || e.keyCode == 13) {
			this.showThisProductSpecificImageGallery(e,a)
		}
	}

	showVariantFeaturedImagesAccessibility(a, b, e){
		if(e.which == 13 || e.keyCode == 13) {
			this.showVariantFeaturedImages(a, b);
		}
	}

	evaluateIfTooManyAccessibility(a,b, e){
		if(e.which == 13 || e.keyCode == 13) {
			this.evaluateIfTooMany(a,b)
		}
	}

	decrementAccessibility(e){
		if(e.which == 13 || e.keyCode == 13) {
			this.decrement(e);
		}
	}

	incrementAccessibility(e){
		if(e.which == 13 || e.keyCode == 13) {
			this.increment(e);
		}
	}

	openInstructionsOverlayAccessibility(e){
		if(e.which == 13 || e.keyCode == 13) {
			this.openInstructionsOverlay(e);
		}
	}

	openVideoOverlayAccessibility(e, link){
		if(e.which == 13 || e.keyCode == 13) {
			this.openVideoOverlay(e, link);
		}
	}


	evaluateVariant(handle, inventory){

		let maxQuantity = this.state.productQuantity
		var elementToUpdateIfAllowed = document.getElementById(handle)
		let elementValue = Number(elementToUpdateIfAllowed.value)
		let elementVariantID = elementToUpdateIfAllowed.getAttribute("data-variant");
		let lastValue = elementToUpdateIfAllowed.getAttribute("data-last-value");
		var allInputValues = document.getElementsByClassName("swatch-quantity");
		let combinedValuesArray = [];

		for (let item of allInputValues) {
			combinedValuesArray.push(Number(item.value));
		}

		let combinedValues = combinedValuesArray.reduce(add, 0);

		if(maxQuantity >= combinedValues && elementValue <= inventory){
			elementToUpdateIfAllowed.value = elementValue
			elementToUpdateIfAllowed.text = elementValue
			this.updateMiniCart(elementValue, elementVariantID);
		}else{
			elementToUpdateIfAllowed.value = lastValue
			elementToUpdateIfAllowed.text = lastValue
			this.updateMiniCart(lastValue, elementVariantID);
		}


	}

	printTotalsMessage(qty, maxQ, product, price, cart){
		var allInputValues = document.getElementsByClassName("swatch-quantity");
		var totalInputCount = 0;

		var productId = product.id

		var newCart = cart.filter(x => x.productID == productId);


		if(newCart[0].hasOwnProperty("cartObjects") && newCart[0].cartObjects.length > 1){
			newCart[0].cartObjects.map((obj, i) =>
				totalInputCount += obj.quanitity
			);
		}

		if(product.options.includes("Color")){
			if(qty < totalInputCount){
				this.setState({
					readyToSave: true
				});
				return "REMOVE PRINTS BELOW TO CONTINUE";
			}else if(qty > totalInputCount){
				this.setState({
					readyToSave: true
				});
				return "SELECT PRINTS BELOW TO CONTINUE";
			}else{
				this.setState({
					readyToSave: true
				});
				return "TOTAL: $" + simplePriceCalc(qty, price/100);
			}
		}else{
			this.setState({
				readyToSave: true
			});
			return "TOTAL: $" + simplePriceCalc(qty, price/100);
		}
	}

	getTotalFromObjectPrice(obj, qty, product){
		var allInputValues = document.getElementsByClassName("swatch-quantity");
		var totalInputCount = 0;
		for (let item of allInputValues) {
			let quant = (Number(item.value));
			let elementVariantID = item.getAttribute("data-variant");
			let price = item.getAttribute("data-variant-price");
			totalInputCount = totalInputCount + quant;
		}
		if(product.options.includes("Color")){
			if(qty < totalInputCount){
				this.setState({
					readyToSave: true
				});
				return "REMOVE PRINTS BELOW TO CONTINUE";
			}else if(qty > totalInputCount){
				this.setState({
					readyToSave: true
				});
				return "SELECT PRINTS BELOW TO CONTINUE";
			}else{
				this.setState({
					readyToSave: true
				});
				return "TOTAL: $" + priceObjectCalulator(obj);
			}
		}else{
			this.setState({
				readyToSave: true
			});
			return "TOTAL: $" + priceObjectCalulator(obj);
		}

	}

	printTotalsMessageAction(qty, price, product, maxQ){
		var allInputValues = document.getElementsByClassName("swatch-quantity");
		var totalInputCount = 0;
		for (let item of allInputValues) {
			let quant = (Number(item.value));
			let elementVariantID = item.getAttribute("data-variant");
			let price = item.getAttribute("data-variant-price");
			totalInputCount = totalInputCount + quant;
		}
		if(product.options.includes("Color")){
			if(qty < totalInputCount){
				this.setState({
					readyToSave: true
				});
				return "REMOVE PRINTS BELOW TO CONTINUE";
			}else if(qty > totalInputCount){
				this.setState({
					readyToSave: true
				});
				return "SELECT PRINTS BELOW TO CONTINUE";
			}else{
				this.setState({
					readyToSave: true
				});
				return "TOTAL: $" + simplePriceCalc(qty, price);
			}
		}else{
			this.setState({
				readyToSave: true
			});
			return "TOTAL: $" + simplePriceCalc(qty, price);
		}
	}

	updateQuantityWhole(e){
		if(this.state.product.options.includes("Color")){
			if( e.target.value > this.state.maxQuantity){
				this.setState({
					productQuantity: this.state.maxQuantity,
					minicart: [{
		                'productID': this.state.product.id,
		                'cartObject': []
		            }],
		            totalprice: this.printTotalsMessageAction(this.state.maxQuantity, this.state.product.variants[0].price/100, this.state.product, this.state.maxQuantity)

				});
			}else{
				this.setState({
					productQuantity: parseInt(e.target.value),
					minicart: [{
		                'productID': this.state.product.id,
		                'cartObject': []
		            }],
		            totalprice: this.printTotalsMessageAction(parseInt(e.target.value), this.state.product.variants[0].price/100, this.state.product, this.state.maxQuantity)

				});
			}
		}else{
			if( e.target.value > this.state.maxQuantity){
				this.setState({
					productQuantity: this.state.maxQuantity,
					minicart: [{
		                'productID': this.state.product.id,
		                'cartObject': []
		            }],
					totalprice: this.printTotalsMessageAction(this.state.maxQuantity, this.state.product.variants[0].price/100, this.state.product, this.state.maxQuantity)

				});
			}else{
				this.setState({
					productQuantity: parseInt(e.target.value),
					minicart: [{
		                'productID': this.state.product.id,
		                'cartObject': []
		            }],
					totalprice: this.printTotalsMessageAction(parseInt(e.target.value), this.state.product.variants[0].price/100, this.state.product, this.state.maxQuantity)
				});
			}
		}
	}

	ifReadyToSaveGoAheadAndSaveAndClose(e){
		if(this.state.readyToSave){
			this.closeOverlayAndSave(e);
		}
	}

	updateQuantity(e){
		var quantity = e.target.value;
		var productId = this.state.product.id
		if( this.state.maxQuantity > this.state.productQuantity){
			this.setState({
				productQuantity: quantity,
				minicart: [{
	                'productID': productId,
	                'cartObject': []
	            }],
				totalprice: this.printTotalsMessageAction(quantity, this.state.product.variants[0].price/100, this.state.product, this.state.maxQuantity)

			});
		}else{

		}

	}

	increment(){
		var productId = this.state.product.id
		if(this.state.product.options.includes("Color")){
			if( this.state.maxQuantity > this.state.productQuantity) {
				var quantity = this.state.productQuantity + 1
				this.setState({
					productQuantity: quantity,
					minicart: {
						'productID': productId,
						'cartObject': []
					},
					totalprice: this.printTotalsMessageAction(quantity, this.state.product.variants[0].price/100, this.state.product, this.state.maxQuantity)

				});
			}
		}else{
			if( this.state.maxQuantity > this.state.productQuantity){
				var quantity = this.state.productQuantity + 1
				this.setState({
					productQuantity: quantity,
					minicart: {
						'productID': productId,
						'cartObject': []
					},
					totalprice: this.printTotalsMessageAction(quantity, this.state.product.variants[0].price/100, this.state.product, this.state.maxQuantity)
				});
			}else{
				var quantity = this.state.productQuantity
				this.setState({
					productQuantity: quantity,
					minicart: {
						'productID': productId,
						'cartObject': []
					},
					totalprice: this.printTotalsMessageAction(quantity, this.state.product.variants[0].price/100, this.state.product, this.state.maxQuantity)
				});
			}
		}
	
	}

	decrement(){

		var productId = this.state.product.id
		var quantity = this.state.productQuantity - 1
		if(this.state.product.options.includes("Color")){
			if(this.state.productQuantity - 1 >= 0){
				this.setState({
					productQuantity: quantity,
					minicart: [{
		                'productID': productId,
		                'cartObject': []
		            }],
		            totalprice: this.printTotalsMessageAction(quantity, this.state.product.variants[0].price/100, this.state.product, this.state.maxQuantity)

	        	});
			}
		}else{
			if(this.state.productQuantity - 1 >= 0){
				this.setState({
					productQuantity: quantity,
					minicart: [{
		                'productID': productId,
		                'cartObject': []
		            }],
					totalprice: this.printTotalsMessageAction(quantity, this.state.product.variants[0].price/100, this.state.product, this.state.maxQuantity)

				});
			}
		}

	
	}

	getDefaultInputValue(variantId){

		if(this.state.cart.length > 0){
			this.state.cart.map((product, i) =>
				{
					if( this.state.product.id == product.productID && product.cartObjects.length > 0){
						product.cartObjects.map((variant, i) =>
							{
								if (variantId == variant.id){
									return variant.quantity
								}
							}
						);
					}else if(this.state.product.id == product.productID){
						var num = 0
						return num
					}else{
						return false
					}

				}
			);
		}
	}

	setActivePrints(x){
		var allVariantThumbnails = document.getElementsByClassName("product-variant-thumbnails");
		for(var i = 0; i < allVariantThumbnails.length; i++){
		   allVariantThumbnails[i].classList.add("hidden")
		}
		let activeVariantThumbnails = document.getElementById("productVariant" + String(x))
		if(activeVariantThumbnails){
			activeVariantThumbnails.classList.remove("hidden");
		}

	}

	showVariantFeaturedImages(x, y){
		this.setState({ activeSwatch: y });

		var allVariantThumbnails = document.getElementsByClassName("product-variant-thumbnails");
		for(var i = 0; i < allVariantThumbnails.length; i++){
		   allVariantThumbnails[i].classList.add("hidden")
		}
		let activeVariantThumbnails = document.getElementById("productVariant" + String(x))
		if(activeVariantThumbnails){
			activeVariantThumbnails.classList.remove("hidden");
			fireClick(activeVariantThumbnails.firstChild.firstChild.firstChild)
			activeVariantThumbnails.firstChild.firstChild.firstChild.classList.add('active')
		}
		const variantThumbnailContainer = document.querySelector('.product-variant-thumbnails:not(.hidden)');
		if (variantThumbnailContainer) {
			const firstThumbnail = variantThumbnailContainer.querySelector('.product__thumbnail');
			const firstThumbnailButton = firstThumbnail.querySelector('button');
			if (firstThumbnail) {
				firstThumbnail.classList.add("active");
				console.log("MOO")
				firstThumbnailButton.setAttribute("aria-current", "true");
			}
		}

		//Set Active Swatch
		var allSwatches = document.getElementsByClassName("variant-swatch");
		for(var i = 0; i < allSwatches.length; i++){
		   allSwatches[i].classList.remove("active")
		}
		let activeSwatch = document.getElementById(y)
		activeSwatch.classList.add("active");
		var thbnailcount = jQuery('.product__thumbnail:visible').length;
		jQuery('.product__thumbnail .product__thumbnail-inner').each(function(){
			jQuery(this).removeAttr('aria-label');
		})
		jQuery('.product__thumbnail:visible .product__thumbnail-inner').each(function(i){
			jQuery(this).attr('aria-label', "image " + (i + 1) + " of " + thbnailcount)
		})
	}


	renderInput(swatchId, variantId){
		return(
			<input type="number"
				id={swatchId}
				data-variant={variantId}
				className="quantity swatch-quantity"
				onChange={this.updateQuantity}>
            </input>
		);
	}

	reduceQuantity(handle){
		var elementToUpdateIfAllowed = document.getElementById(handle)
		let elementValue = Number(elementToUpdateIfAllowed.value)
		let elementVariantID = elementToUpdateIfAllowed.getAttribute("data-variant");

		if(elementValue > 0){
			elementToUpdateIfAllowed.setAttribute('data-last-value',elementValue - 1)
			elementToUpdateIfAllowed.value = elementValue - 1
			elementToUpdateIfAllowed.text = elementValue - 1
			this.updateMiniCart(elementValue - 1, elementVariantID);
		}else{
			elementToUpdateIfAllowed.setAttribute('data-last-value',elementValue)
		}

	}

	evaluateIfTooMany(handle, inventory){

		let maxQuantity = this.state.productQuantity
		var allInputValues = document.getElementsByClassName("swatch-quantity");
		var elementToUpdateIfAllowed = document.getElementById(handle);
		let elementValue = Number(elementToUpdateIfAllowed.value)
		let elementVariantID = elementToUpdateIfAllowed.getAttribute("data-variant");

		let combinedValuesArray = [];

		for (let item of allInputValues) {
			combinedValuesArray.push(Number(item.value));
		}

		let combinedValues = combinedValuesArray.reduce(add, 0);

		if(maxQuantity > combinedValues && inventory == true){
			elementToUpdateIfAllowed.setAttribute('data-last-value',elementValue + 1)
			elementToUpdateIfAllowed.value = elementValue + 1
			elementToUpdateIfAllowed.text = elementValue + 1
			this.updateMiniCart(elementValue + 1, elementVariantID);
		}else{
			elementToUpdateIfAllowed.setAttribute('data-last-value',elementValue)
		}

	}

	renderSwatchImage(handleOne){
		let imageElement = '';
		let swatchImage = '';
		let swatchObj = window.swatches.find(x => x.name === handleOne);
		if(swatchObj){
			swatchImage = swatchObj.image;
			imageElement = <img src={"https:" + swatchImage} alt={handleOne} className="swatch-image" />
		}else{
			imageElement = '';
		}

  		return(
  			<div className="swatch-image-wrapper">
  				{imageElement}
  				<img src={soldout} className="sold-out" alt="Out of Stock"/>
  				<span className="visually-hidden">{handleOne}</span>

  			</div>
	  	);
	}


	renderDescription(product){
		let data = product

		if (Object.keys(data).length == 0 && data.constructor == Object){

		}else{
			if (data.meta.kitDescription){
				this.setState({
					description: data.meta.kitDescription
				});
			} else {
				this.setState({
					description: HtmlEncode(data.description)
				});
			}
		}
	}

	renderBackgroundImage(product){

		let array = [];
		let splitImagesArray = [];
      	let result = [];
      	let obj;
      	let v;
      	let k;

		if (product.featured_image){

			if(product.meta.hasOwnProperty("kitImages") && product.meta.kitImages.length > 0 && product.meta.kitImages[0].images.length > 0){
				this.setState({
					backgroundImage: "<div class='featured-background' style='background-image: url(" + product.meta.kitImages[0].images[0].image + ")'><span></span></div>"
				});
			} else {
				this.setState({
					backgroundImage: "<div class='featured-background' style='background-image: url(" + product.featured_image + ")'><span></span></div>"
				});
			}

		}else{
			this.setState({
				backgroundImage: "<div class='featured-background'><span></span></div>"
			});
		}

		if(product.meta.hasOwnProperty("kitImages") && product.meta.kitImages.length > 0 && product.meta.kitImages[0].imageIdHook !== ""){
		    this.setState({
		    	imageVariants: product.meta.kitImages,
		    	galleryImages: product.meta.galleryImages,
		    	singleImage: ''
		    }, () => {
				this.setActivePrints(product.variants[0].featured_image.id);
				let allVariantImages = document.getElementsByClassName("background-variant-image");
			    if (allVariantImages.length > 0){
			    	allVariantImages[0].classList.remove('hidden');
					allVariantImages[0].childNodes[0].classList.remove('hidden');
					allVariantImages[0].childNodes[0].classList.add('move-up');
					if(allVariantImages[0].childNodes[0].childNodes.length > 0){
				    	allVariantImages[0].childNodes[0].childNodes[0].classList.remove('hidden');
				    	allVariantImages[0].childNodes[0].childNodes[0].classList.add('move-up');
				    }
			    	let activeVariantThumbnails = document.getElementsByClassName("product-variant-thumbnails");
			    	let globalProductThumbnails = document.querySelectorAll('.global-product-thumbnails');
			    	if(activeVariantThumbnails[0].firstChild.firstChild){
						activeVariantThumbnails[0].firstChild.firstChild.classList.add('active');
					}else{
						if(globalProductThumbnails.length > 0){
							if(globalProductThumbnails[0].firstChild.firstChild){
								globalProductThumbnails[0].firstChild.firstChild.classList.add('active');
								let globalProductImageInitial = document.querySelectorAll('.background-gallery-image');
								if(globalProductImageInitial.length > 0 ){
									globalProductImageInitial[0].classList.remove('hidden');
									globalProductImageInitial[0].classList.add('move-up');
								}
							}
						}
					}
					var thbnailcount = jQuery('.product__thumbnail:visible').length;
						jQuery('.product__thumbnail:visible .product__thumbnail-inner').each(function(i){
							jQuery(this).attr('aria-label', "image " + (i + 1) + " of " + thbnailcount)
					})
			    }
			});

		}else{
	    	this.setState({
		    	imageVariants: [],
		    	galleryImages: [],
		    	singleImage: product.images[0]
		    }, () => {
		    	let allVariantImages = document.getElementsByClassName("background-variant-image");
			    if (allVariantImages.length > 0){
			    	allVariantImages[0].classList.remove('hidden');
					allVariantImages[0].childNodes[0].classList.remove('hidden');
		    		allVariantImages[0].childNodes[0].classList.add('move-up');
			    	allVariantImages[0].childNodes[0].childNodes[0].classList.remove('hidden');
			    	allVariantImages[0].childNodes[0].childNodes[0].classList.add('move-up');
					let activeVariantThumbnails = document.getElementsByClassName("product-variant-thumbnails");
					let globalProductThumbnails = document.querySelectorAll('.global-product-thumbnails');
					if(activeVariantThumbnails[0].firstChild.firstChild){
						activeVariantThumbnails[0].firstChild.firstChild.classList.add('active')
					}else{
						if(globalProductThumbnails.length > 0){
							if(globalProductThumbnails[0].firstChild.firstChild){
								globalProductThumbnails[0].firstChild.firstChild.classList.add('active');
								let globalProductImageInitial = document.querySelectorAll('.background-gallery-image');
								if(globalProductImageInitial.length > 0 ){
									globalProductImageInitial[0].classList.remove('hidden');
									globalProductImageInitial[0].classList.add('move-up');
								}
							}
						}
					}
			    }
		    });
	    }

	}

	renderPrints(product){
		var color = product.options.includes("Color");
		let productVariants = [];
		if (product.variants.length > 1){
			product.variants.map((variant, i) =>
				{
					if(color == true){
						productVariants.push(variant);
					}else if(variant.option2 != null){
						if( variant.option2.toLowerCase() === this.state.size.toLowerCase() ){
							productVariants.push(variant);
						}
					}else{

					}
				}
			);

		}else{

		}

		this.setState({
			productVariants: productVariants,
			activeSwatch: productVariants.length > 0 ? productVariants[0].id + "X0" : null
		}, () => {

		});
		
	}

	renderVideoIframe(x){
		return <ReactPlayer controls="true" url={x} title="How-to video on Diapering" className="vimeo-wrapper-overlay" width="calc(98% - 40px)" height="52vw" />
	}

	showThisProductSpecificImage(e, x, y){
		jQuery('html, body, .product-overlay .inner').animate({scrollTop: 0}, 500);

		// The button element this handler is attached to
		const button = e.currentTarget;
		const listItem = button.closest('.product__thumbnail');

		// Remove 'active' from previously selected item
		const current = document.querySelector('.product__thumbnail.active');
		if (current) {
			const currentButton = current.querySelector('button');
			current.classList.remove("active");
			if (currentButton) {
				currentButton.removeAttribute("aria-current");
			}
		}

		// Add 'active' to the clicked/focused item
		listItem.classList.add("active");
		button.setAttribute("aria-current", "true");

		// Show Variant Background Images
		var allVariantBGs = document.getElementsByClassName("background-product-image");
		for(var i = 0; i < allVariantBGs.length; i++){
		   allVariantBGs[i].classList.add("hidden")
		   allVariantBGs[i].classList.remove("move-up")
		}

		var allGalleryBGImages = document.getElementsByClassName("background-gallery-image");
		for(var i = 0; i < allGalleryBGImages.length; i++){
		   allGalleryBGImages[i].classList.add("hidden")
		   allGalleryBGImages[i].classList.remove("move-up")
		}

		var activeVariantWrapper = document.getElementById(x)
		activeVariantWrapper.classList.add("move-up")
		activeVariantWrapper.classList.remove("hidden")

		var allVariantBGImages = document.getElementsByClassName("background-product-image");
		for(var i = 0; i < allVariantBGImages.length; i++){
		   allVariantBGImages[i].classList.add("hidden")
		   allVariantBGImages[i].classList.remove("move-up")
		}
		let activeVariantBGs = document.getElementById(x).childNodes

		var elm = {};
		for (var i = 0; i < activeVariantBGs.length; i++) {
	        if (activeVariantBGs[i].id === y) {
	            elm = activeVariantBGs[i];
	            break;
	        }
	    }

		elm.classList.remove("hidden");
		elm.classList.add("move-up");
	}

	showThisProductSpecificImageGallery(e, x){
		jQuery('html, body, .product-overlay .inner').animate({ scrollTop: 0 }, 500);

		const button = e.currentTarget;
		const listItem = button.closest('.product__thumbnail');
	
		// Remove existing active class and aria-current
		const current = document.querySelector('.product__thumbnail.active');
		if (current) {
			current.classList.remove('active');
			const currentButton = current.querySelector('button');
			if (currentButton) {
				currentButton.removeAttribute('aria-current');
			}
		}
	
		// Check if it's the Enter key (keyboard activation)
		const isEnterKey = e.which === 13 || e.keyCode === 13;
	
		// Set active class and aria-current
		listItem.classList.add('active');
		button.setAttribute('aria-current', 'true');
		
		var allVariantBGs = document.getElementsByClassName("background-variant-image");
		for(var i = 0; i < allVariantBGs.length; i++){
		   allVariantBGs[i].classList.add("hidden")
		   allVariantBGs[i].classList.remove("move-up")
		}

		var allGalleryBGImages = document.getElementsByClassName("background-gallery-image");
		for(var i = 0; i < allGalleryBGImages.length; i++){
		   allGalleryBGImages[i].classList.add("hidden")
		   allGalleryBGImages[i].classList.remove("move-up")
		}

		let activeGalleryBG = document.getElementById(x)

		activeGalleryBG.classList.remove("hidden");
		activeGalleryBG.classList.add("move-up");
	}

	openVideoOverlay(e, videoURL){

		this.setState({
			videoOverlayURL: videoURL
		}, () => {
			this.setState({ videoOverlay: true }, () => {
				setTimeout(() => {
					const closeBtn = document.querySelector('.js-video-lightbox-close');
					closeBtn.focus();
				}, 1000);
			});
			const closeBtn = document.querySelector('.js-video-lightbox-close');
			closeBtn.focus();

		});
	}

	closeVideoOverlay(){
		
		this.setState({
			videoOverlay: false
		}, () => {
			this.setState({
				videoOverlayURL: ''
			});
			var ele = document.getElementById('close-kit-video-overlay');
			ele.focus();
		});
	}

	closeInstructionsOverlay(){
		this.setState({
			instructionsOverlay: false
		}, () => {
			this.setState({
				instructions: ''
			});
			var ele = document.getElementById('product-instructions-overlay-button');
			ele.focus();
		});
	}

	renderNewInstructions(i){
		return (
			<div className="instructions-outer">
				<div className="instructions-inner">
					{i}
				</div>
			</div>
	    );
	}

	openInstructionsOverlay(e, i){
		this.setState({
			instructions: i
		}, () => {
			this.setState({
				instructionsOverlay: true
			});
			var ele = document.getElementById('close-instructions-overlay');
			ele.focus();
		});
	}

	updateMiniCart(closed){
		let eleOv = document.querySelector('.kit .product-overlay .inner');
		eleOv.scrollTop = 0;
		let cartObjects = [];
		let close = closed
		// let newObj = {};

		var allInputValues = document.getElementsByClassName("swatch-quantity");

		for (let item of allInputValues) {
			let quant = (Number(item.value));
			let elementVariantID = item.getAttribute("data-variant");
			let price =  item.getAttribute("data-variant-price");
			let object = {
				id: elementVariantID,
				quanitity: quant,
				price: price
			}
			cartObjects.push(object)
		}

		let productID = this.state.product.id

		if (hasRun === ""){
			newObj = new obj();
			hasRun = "ran";
		}

		newObj.add('productID', productID);
		newObj.add('cartObject', cartObjects);

		this.setState({
			minicart: newObj.obj,
			totalprice: this.getTotalFromObjectPrice(newObj.obj, this.state.productQuantity, this.state.product)
		}, () => {
			if(close === "close"){
				if(this.state.productVariants.length > 0){
					this.props.closeOverlayAndSave(this.state.panel, this.state.productQuantity, this.state.minicart, this.state.product.id);
				}else{
					let productQuantity = this.state.productQuantity
					let productVariantID = this.state.product.variants[0].id
					let productPrice = this.state.product.variants[0].price
					let miniCartSingleVariant = {
						'productID': this.state.product.id,
						'cartObject': [{
							id: productVariantID,
							quanitity: productQuantity,
							price: productPrice
						}]
					}
					this.props.closeOverlayAndSave(this.state.panel, this.state.productQuantity, miniCartSingleVariant, this.state.product.id);

				}
			}

		});

	}

	updateOverlayState(product, qty, panel, babySize, cart, event, maxQ){
		let eleOv = document.querySelector('.kit .product-overlay .inner');
		eleOv.scrollTop = 0;
		let price = priceCalulator(cart, product.id)

		this.setState({
			product: product,
			price: product.variants[0].price,
			panel: panel,
			productQuantity: evaluateIfSoldOutReturnQ(product, qty),
			size: babySize,
			title: product.title,
			cart: cart,
			maxQuantity: evaluateIfSoldOutReturnQ(product, maxQ),
			imageVariants: [],
			galleryImages: []
		}, () => {
			this.renderPrints(product);
			this.setState({
				totalprice: this.printTotalsMessage(evaluateIfSoldOutReturnQ(product, qty), evaluateIfSoldOutReturnQ(product, maxQ), product, product.variants[0].price, cart),
			});
			this.renderBackgroundImage(product);
			this.renderDescription(product);
		});

	}

	closeOverlayAndSave(){
		const lastFocused = document.getElementById(window.lastFocusedPropsID);
		if (lastFocused) lastFocused.focus();
		this.updateMiniCart("close");
	}


	trapFocusKeydown = (e) => {
	if (!this.state.videoOverlay) return;

	const modal = document.querySelector('.lightbox-overlay.open.active');
	if (!modal) return;

	const focusableEls = modal.querySelectorAll(
		'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"])'
	);

	const focusable = Array.prototype.slice.call(focusableEls);
	if (!focusable.length) return;

	const firstEl = focusable[0];
	const lastEl = focusable[focusable.length - 1];

	// TAB
	if (e.key === "Tab" || e.keyCode === 9) {
		const active = document.activeElement;

		// SHIFT+TAB on first element → cycle to last
		if (e.shiftKey && active === firstEl) {
		e.preventDefault();
		lastEl.focus();
		}

		// TAB on last element → cycle to first
		else if (!e.shiftKey && active === lastEl) {
		e.preventDefault();
		firstEl.focus();
		}

		// Edge case: focus has left modal (e.g., iframe swallowed it)
		else if (!modal.contains(active)) {
		e.preventDefault();
		firstEl.focus();
		}
	}
	};

componentDidUpdate(prevProps) {
  if (!prevProps.detailOverlay && this.props.detailOverlay) {
    setTimeout(() => {
      const closeBtn = document.getElementById('go-back-to-product');
      if (closeBtn) closeBtn.focus();
    }, 0);
  }
}


	componentDidMount() {
	document.addEventListener("keydown", this.trapFocusKeydown);
	document.addEventListener('keydown', this.handleKeyDown);
	document.addEventListener('keyup', this.handleKeyUp);
	  document.addEventListener("keydown", this.trapDetailOverlayFocus);

	}

	componentWillUnmount() {
	document.removeEventListener("keydown", this.trapFocusKeydown);
	document.removeEventListener('keydown', this.handleKeyDown);
	document.removeEventListener('keyup', this.handleKeyUp);
	  document.removeEventListener("keydown", this.trapDetailOverlayFocus);

	}

	handleKeyDown = (e) => {
	if (e.key === 'Shift') {
		this.shiftPressed = true;
	}
	};

	handleKeyUp = (e) => {
	if (e.key === 'Shift') {
		this.shiftPressed = false;
	}
	};

	trapDetailOverlayFocus = (e) => {
	if (!this.props.detailOverlay) return;

	const modal = document.querySelector('.po-unid.active');
	if (!modal) return;

	const closeBtn = document.getElementById('go-back-to-product');
	const lastBtnContainer = modal.querySelector('.overlay-buttons-container');
	const lastBtns = lastBtnContainer ? lastBtnContainer.querySelectorAll('button:not([disabled])') : [];

	const last = lastBtns[lastBtns.length - 1];

	if (!closeBtn || !last) return;

	if (e.key === "Tab" || e.keyCode === 9) {
		if (e.shiftKey) {
			// Reverse tabbing: from first to last
			if (document.activeElement === closeBtn) {
				e.preventDefault();
				last.focus();
			}
		} else {
			// Forward tabbing: from last to first
			if (document.activeElement === last) {
				e.preventDefault();
				closeBtn.focus();
			}
		}
	}
	};

	render(){

    	return (
	    	<div className={(this.props.detailOverlay ? 'active product-overlay po-unid' : 'product-overlay po-unid')} aria-label={"Product information on " + this.state.title} id="panel" role="dialog" aria-modal="true">

			 	<div className="inner" >
			 	<button id="go-back-to-product" disabled={(this.state.readyToSave ? false : true)} className={(this.state.readyToSave ? 'close-icon' : 'inactive close-icon')} onClick={ this.ifReadyToSaveGoAheadAndSaveAndClose } onKeyPress={ e => this.ifReadyToSaveGoAheadAndSaveAndCloseAccessibility(e) } aria-label="Close"></button>
				<div role="region" aria-label="carousel">
					<div className="overlay-thumbnails-wrapper">
						<ul>

							{ this.state.imageVariants.length > 0 &&
							this.state.imageVariants.map((imageContainer, containerIndex) =>
								<li className="product-variant-thumbnails hidden" id={`productVariant${imageContainer.imageIdHook}`} key={`pv${containerIndex}`}>
								<ul>
									{ imageContainer.images.map((image, i) => (
										<li className="product__thumbnail" key={`pvd${i}`}>
										<button
											className={`product__thumbnail-inner ${i === 0 ? 'active' : ''}`}
											aria-current={i === 0 ? 'true' : undefined}
											onClick={e => this.showThisProductSpecificImage(e, `productVariantBG${imageContainer.imageIdHook}`, `productVariantBG${i}`)}
											onKeyPress={e => this.showThisProductSpecificImageAccessibility(e, `productVariantBG${imageContainer.imageIdHook}`, `productVariantBG${i}`)}
										>
											<span>
											<img data-src={image.image} className="lazyload" alt={image.alt} />
											</span>
										</button>
										</li>
									))
									}
								</ul>
								</li>
							)
							}
							{ this.state.galleryImages.length > 0 &&
								<ul className="global-product-thumbnails">
									{
										this.state.galleryImages.map((image, i) =>
											<li className="product__thumbnail">
												<button className="product__thumbnail-inner" onClick={e => this.showThisProductSpecificImageGallery(e, "productBG" + i)} key={'productBG'+ i}  onKeyPress={e => this.showThisProductSpecificImageGalleryAccessibility(e, "productBG" + i)}>
													<span style={{backgroundImage: `url(${image.image})`}}>
														<img data-src={image.image} className="lazyload" alt={image.alt}/>
													</span>
												</button>
											</li>
										)
									}
								</ul>
							}

						</ul>
					</div>



					{ window.innerWidth > 768 &&

						<div className="desktop-images">

							{ this.state.imageVariants.length > 0 &&
								this.state.imageVariants.map((imageContainer, i) =>
									<div className='background-variant-image hidden' id={"productVariantBG" + String(imageContainer.imageIdHook)} key={'pbbgc'+ i}>
										{
											imageContainer.images.map((image, i) =>
												<div className="background-product-image hidden" id={"productVariantBG" + i} key={'pbbg'+ i}>
													<img data-src={image.image} className="lazyload" alt={image.alt}/>
												</div>
											)
										}
									</div>
								)
							}
							{ this.state.galleryImages.length > 0 &&
								this.state.galleryImages.map((image, i) =>
									<div className="background-gallery-image hidden" id={"productBG" + i} key={'bgi'+ i}>
										<img data-src={image.image} className="lazyload" alt={image.alt}/>
									</div>
								)
							}
						</div>
					}

					{ window.innerWidth < 769 &&

						<div className="mobile-images">
							{ this.state.imageVariants.length > 0 &&
								this.state.imageVariants.map((imageContainer, i) =>
									<div className='background-variant-image hidden' id={"productVariantBG" + String(imageContainer.imageIdHook)} key={'pbbgc'+ i}>
										<Flickity
										key={'productFlickityKey'+ i}
										flickityRef={c => this.flkty = c}
										className={'carousel'} // default ''
										elementType={'div'} // default 'div'
										options={flickityOptions} // takes flickity options {}
										disableImagesLoaded={false} // default false
										>
										{
											imageContainer.images.map((image, i) =>
												<div className="background-product-image hidden" id={"productVariantBG" + i} key={'pbbg'+ i}>
													<img data-src={image.image} className="lazyload" alt={image.alt} />
												</div>
											)
										}
										{ this.state.galleryImages.length > 0 &&
											this.state.galleryImages.map((image, i) =>
												<div className="background-gallery-image hidden" id={"productBG" + i} key={'bgi'+ i}>
													<img data-src={image.image} className="lazyload" alt={image.alt} />
												</div>
											)
										}
										</Flickity>
									</div>
								)
							}
						</div>
					}
				</div>



			 	 	{ this.state.singleImage !== "" &&
			 	 		<div className="background-mobile-single" dangerouslySetInnerHTML={{__html: this.state.backgroundImage}}></div>
			 	 	}

			 		<div className="product-query-box">
			 			<div className="product-top-left">
			 				<h1 className="product-single__title">
								{ this.state.product.meta.kitTitle != undefined &&
									this.state.product.meta.kitTitle == "" &&
									this.state.title
								}
								{ this.state.product.meta.kitTitle != undefined &&
									this.state.product.meta.kitTitle != "" &&
									this.state.product.meta.kitTitle
								}
							</h1>
			 			</div>
				 		<div className="product-single__price">${ formatMoney(this.state.price/100) } each</div>

			 			<div className="product-size">
			 				{ this.state.product.variants[0].options.includes(this.state.size) &&
			 					<span>Size {this.state.size} </span>
			 				}
			 				{this.state.product.meta.hasOwnProperty("kitPackNote") && this.state.product.meta.kitPackNote !== "" &&
			 					<span>{this.state.product.meta.kitPackNote}</span>
			 				}
			 			</div>


			            { this.state.description !== "" &&
							<div className="product-single-description" dangerouslySetInnerHTML={{__html: ReactHtmlParser(this.state.description)}}></div>
			        	}

			        	<div className="product--overall-quantity">
			        		<label htmlFor="productQuantityFormLabel" className="product__descriptor">Quantity:</label>
				        	<div className="product__quantity">
				        		<button className="quantity--decrement" onClick={this.decrement} aria-label="decrease quantity by one">-</button>
				        		<input type="number"
				        			   aria-label="quantity"
				        			   id="productQuantityFormLabel"
                                       className="quantity"
                                       defaultValue={this.state.productQuantity}
                                       value={this.state.productQuantity}
                                       onChange={e => this.updateQuantityWhole(e)} 
                                       >
                                </input>
				        		<button className="quantity--increment" onClick={this.increment}  aria-label="increase quantity by one">+</button>
				        	</div>

				        	<div className="product__total">
				        		{this.state.totalprice}
				        	</div>

				        </div>
			        	{ this.state.productVariants.length > 0 &&
			        		this.state.productVariants.map((variant, ii) =>
				        		{
				        		 	return(
										<div className={"variant-swatch " + evaluateIfSoldOut(variant.available) + " " + this.evaluateIfActive(ii) + " " + this.getSlugHandle(variant.option1, variant.option2)} key={"swatch-" + ii} id={variant.id + "X" + ii}>
									  		<button
												className="product-upper"
												aria-pressed={this.state.activeSwatch === variant.id + "X" + ii}
												onClick={e => this.showVariantFeaturedImages(variant.featured_image.id, variant.id + "X" + ii)}
												onKeyPress={e => this.showVariantFeaturedImagesAccessibility(variant.featured_image.id, variant.id + "X" + ii, e)}
												>
													{this.renderSwatchImage(variant.option1, variant.option2)}
											</button>
									  		<div className="product-lower">
									  			<div className="product__quantity">
									  				<button className="quantity--increment" onClick={e => this.reduceQuantity("swatch-" + ii)}  aria-label="decrease quantity by one" disabled={evaluateIfSoldOut(variant.available)}>-</button>
									  				{ this.state.cart.length > 0 &&
														this.state.cart.map((product, i) =>
															<frag>
															{ this.state.product.id === product.productID &&
																product.cartObjects.length > 0 &&

																	product.cartObjects.map((vc, i) =>

                                                                        <frag>

																		{ variant.id == vc.id &&
																			<span className="product__input-text">
																				<input type="number"
																						aria-label="swatch quantity"
                                                                                       id={"swatch-" + ii}
                                                                                       data-variant={variant.id}
                                                                                       data-variant-price={variant.price}
                                                                                       className="quantity swatch-quantity"
                                                                                       defaultValue={vc.quanitity}
                                                                                       onChange={e => this.updateQuantity()}
                                                                                       onKeyPress={e => this.updateQuantityAccessibility(e)}
																					   disabled={!variant.available}
                                                                                       >
                                                                                </input>
																			</span>
																		}
                                                                        </frag>
																	)

															}
															{ this.state.product.id == product.productID &&
																product.cartObjects.length == 0 &&
																	<span className="product__input-text">
																		<input type="number"
																			   aria-label="swatch quantity"
                                                                               id={"swatch-" + ii}
                                                                               data-variant={variant.id}
                                                                               data-variant-price={variant.price}
                                                                               data-last-value={0}
                                                                               className="quantity swatch-quantity"
                                                                               defaultValue="0"
                                                                               onChange={e => this.evaluateVariant("swatch-" + ii, variant.available)}
                                                                               onKeyPress={e => this.evaluateVariantAccessibility(a, b, e)}
																			   disabled={!variant.available}
                                                                               >
                                                                        </input>
																	</span>
															}
															</frag>
														)
													}
									  				<button className="quantity--decrement" onClick={e => this.evaluateIfTooMany("swatch-" + ii, variant.available)} aria-label="increase quantity by one" disabled={!variant.available}>+</button>
									  			</div>
									  		</div>
									  	</div>
									);
				        		}
							)
			        	}
			        	{ this.state.productVariants.length < 1 &&
			        		<div className="shrink-vertically"></div>
			        	}
			        	<div className="product--overall-quantity overlay-buttons-container">

				        	<button disabled={(this.state.readyToSave ? false : true)} className={(this.state.readyToSave ? 'btn' : 'inactive btn')} onClick={ this.ifReadyToSaveGoAheadAndSaveAndClose } onKeyPress={e => this.ifReadyToSaveGoAheadAndSaveAndCloseAccessibility(e)}>Save and Close</button>

				        	{ this.state.product.meta.hasOwnProperty("kitVideo") && this.state.product.meta.kitVideo !== "" &&
						 		<button
									id="close-kit-video-overlay"
									className="video-overlay-toggle"
									onClick={e => this.openVideoOverlay(e, this.state.product.meta.kitVideo)}
									onKeyPress={e => this.openVideoOverlayAccessibility(e, this.state.product.meta.kitVideo)}
									>
									{this.state.title} Tutorial
								</button>
						 	}

						 	{ this.state.product.meta.hasOwnProperty("kitCare") && this.state.product.meta.kitCare !== "" &&
						 		<button aria-label="Open instructions overlay" id="product-instructions-overlay-button" className="instructions-toggle" onClick={e => this.openInstructionsOverlay(e, this.state.product.meta.kitCare)} onKeyPress={e => this.openInstructionsOverlayAccessibility(e, this.state.product.meta.kitCare)}>Care instructions</button>
						 	}

				        </div>

				 	</div>
		
				</div>
				<div role="dialog" aria-modal="true" aria-label="How-to video on { this.state.title }" className={(this.state.videoOverlay ? 'open active lightbox-overlay' : ' lightbox-overlay')}>
					<button aria-label="Close Video Overlay" className="js-lightbox-close js-video-lightbox-close lightbox-close" onClick={e => this.closeVideoOverlay()} onKeyPress={e => this.closeVideoOverlayAccessibility(e)}><div><span></span></div></button>
				    {
				    	this.renderVideoIframe(this.state.videoOverlayURL)
				    }
					<div
						tabIndex={0}
						aria-live="polite"
						className="video-modal-end-trap"
						>
						<span className="visually-visible">
							You are at the end of the video overlay. Use Tab to return to the close button or Shift + Tab to return to the video.
						</span>
					</div>
				</div>
				<div role="dialog" aria-modal="true" aria-label="Instructional video on { this.state.title }" className={(this.state.instructionsOverlay ? 'open active lightbox-overlay' : ' lightbox-overlay')}>
					<button aria-label="Close Instructions Overlay" id="close-instructions-overlay" className="js-lightbox-close lightbox-close" onClick={e => this.closeInstructionsOverlay()} onKeyPress={e => this.closeInstructionsOverlayAccessibility(e)}><div><span></span></div></button>
				    {
				    	this.renderNewInstructions(this.state.instructions)
				    }
				</div>
			</div>
		)
	}
};

export default ProductOverlay;
